<nav class="d-lg-block d-none" style="background: #0a5ea7;">
    <ul class="nav nav-tabs" id="nav-tab" role="tablist">
        <li class="nav-item">
            <button class="nav-link" (click)="activesection='content'" [class.active]="activesection == 'content'"
                id="nav-content-tab" data-bs-toggle="tab" data-bs-target="#nav-content" role="tab" aria-controls="nav-content"
                aria-selected="false"> <i class="icon-bar"></i>
                Content</button>
        </li>
        <li class="nav-item">
            <button class="nav-link" (click)="activesection='notes'" [class.active]="activesection == 'notes'"
                id="nav-notes-tab" data-bs-toggle="tab" data-bs-target="#nav-notes" role="tab" aria-controls="nav-notes"
                aria-selected="true"> <i class="icon-file"></i>
                Notes</button>
        </li>
        <li [class.pointer-events-none]="isLocked" class="nav-item" *ngIf="resourceExists">
            <button class="nav-link" (click)="activesection='resources'" [class.active]="activesection == 'resources'"
                id="nav-resources-tab" data-bs-toggle="tab" data-bs-target="#nav-resources" role="tab"
                aria-controls="nav-resources" aria-selected="true"> <i [class.icon-download]="!isLocked"
                    [class.icon-lock]="isLocked"></i>
                Resources</button>
        </li>
        <ng-container *ngIf="course?.isQna">
            <li class="nav-item">
                <button class="nav-link" (click)="activesection='qanda'" [class.active]="activesection == 'qanda'"
                    id="nav-qanda-tab" data-bs-toggle="tab" data-bs-target="#nav-qanda" role="tab" aria-controls="nav-qanda"
                    aria-selected="false">
                    Q&amp;A <sup class=""
                        style="background: #DD2C00; color: #fff; padding: 0px 3px; border-radius: 5px; font-size: 10px; min-width: 20px;">{{totalMessageLength}}</sup>
                </button>
            </li>
        </ng-container>
    </ul>
</nav>
<nav class="d-block d-lg-none" style="background: #0a5ea7;">
    <ul class="nav nav-tabs MobTab">
        <li class="nav-item">
            <button class="nav-link" (click)="activeContent=!activeContent" id="Content">
                <ng-container *ngIf="!course?.isQna"> <i class="icon-bar"></i> </ng-container>
                Content
            </button>
        </li>
        <li class="nav-item">
            <button class="nav-link" (click)="activeNotes=!activeNotes" id="Notes">
                <ng-container *ngIf="!course?.isQna"> <i class="icon-file"></i> </ng-container> Notes
            </button>
        </li>
        <li class="nav-item" *ngIf="resourceExists">
            <button class="nav-link" (click)="activeResources=!activeResources" id="Resources">
                <ng-container *ngIf="!course?.isQna"> <i [class.icon-download]="!isLocked"
                        [class.icon-lock]="isLocked"></i> </ng-container>
                Resources
            </button>
        </li>
        <li *ngIf="course?.isQna" class="nav-item">
            <button class="nav-link" (click)="activeQanda=!activeQanda" id="nav-qanda-tab">Q&amp;A<sup class=""
                    style="background: #DD2C00; color: #fff; padding: 0px 3px; border-radius: 5px; font-size: 10px; min-width: 20px;">{{totalMessageLength}}</sup></button>
        </li>
    </ul>
</nav>
<div class="tab-content" id="nav-tabContent" style="background: #0a5ea7;">
    <app-notes [courseId]="courseId" class="tab-pane fade" [class.show]="activesection == 'notes'"
        [class.active]="activesection == 'notes'" [class.activeTAb]="activeNotes" (close)="activeNotes=false"
        id="nav-notes" role="tabpanel" aria-labelledby="nav-notes-tab"></app-notes>
    <app-content [courseId]="courseId" (sideBarClicked)="emitEvent()" class="tab-pane fade"
        (openModuleOverview)="showModuleOverview($event)" [class.show]="activesection == 'content'"
        [class.active]="activesection == 'content'" [moduleOverview]="moduleOverview"
        (hideWalkthrough)="_hideWalkthrough()" (hideCourseProgress)="_hideCourseProgress()"
        [class.activeTAb]="activeContent" (close)="activeContent=false" id="nav-content" role="tabpanel"
        aria-labelledby="nav-content-tab"></app-content>
    <app-resources (sideBarClicked)="emitEvent()" class="tab-pane fade" [courseId]="courseId"
        [class.show]="activesection == 'resources'" [class.active]="activesection == 'resources'"
        [class.activeTAb]="activeResources" (close)="activeResources=false" id="nav-resources" role="tabpanel"
        aria-labelledby="nav-resources-tab"></app-resources>
    <ng-container>
        <!-- <app-qanda class="tab-pane fade" [courseId]="courseId" [class.show]="activesection == 'qanda'"
            [class.active]="activesection == 'qanda'" [class.activeTAb]="activeQanda" (close)="activeQanda=false"
            (totalMessage)="getMessageLength($event)" id="nav-qanda" role="tabpanel" aria-labelaledby="nav-qanda-tab">
        </app-qanda> -->
    </ng-container>

</div>